import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from 'app/core/auth/auth.service';
import { compactNavigation } from 'app/core/navigation/data';
import _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard {
    routeValidation: any;
    constructor(public auth: AuthService, public router: Router) {
        this.routeValidation = _.flatten(compactNavigation.map((record) => {
            if(record.children) {
                const returnData = record.children.map((child: any) => ({id: child.id, link: child.link, moduleKey: child.moduleKey}));
                return returnData;
            }
            else {
                return {id: record.id, link: record.link, moduleKey: record.moduleKey};
            }
        }));
     }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['login']);
            return false;
        }else{
            (window as any).Beamer?.init();
            const currentModule = this.routeValidation?.filter((data: any)=>state?.url.includes(data?.link))?.[0];
            if(!this.auth.isModuleAccessable(currentModule, state)){
                window.history.back();
                return false;
            }
        }
        return true;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['login']);
            return false;
        }else{
            const currentModule = this.routeValidation?.filter((data: any)=> state?.url.includes(data?.link))?.[0];
            if(!this.auth.isModuleAccessable(currentModule)){
                window.history.back();
                return false;
            }
        }
        return true;
    }
}
